

























	import { ProductListFilter } from "@/model/product-list-filter";
	import Vue from "vue";

	export default Vue.extend({
		name: "ProductSearch",
		props: {
			activeFilter: {
				type: Object as () => ProductListFilter,
				required: true
			}
		},
		watch: {
			activeFilter() {
			}
		},
		methods: {
			clearAllFilters() {
				this.activeFilter.getAllFilterOptions().forEach(({name, value}: { name: string, value: string }) => this.activeFilter.removeFilterOption(
					name, value
                ));
				this.$emit('updated');
            },
			clear() {
				this.activeFilter.clearQuery();
				this.$emit('updated');
			}
		}
	});
